import React, {
    useCallback, useEffect, useMemo, useContext
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react'
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './AdditionalConditionsofPolicyComponent.module.scss';
import metadata from './AdditionalConditionsofPolicyComponent.metadata.json5';

function AdditionalConditionsofPolicyComponent(props) {

const {
        data: AdditionalConditionsofPolicyVM,
        updateWizardData,
        submissionVM,
        AdditionalConditionsofPolicyPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


   const addAdditionalConditionsofPolicy = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            AdditionalConditionsofPolicyVM.value = AdditionalConditionsofPolicyVM.value || []

            const { _xCenter, _dtoName } = AdditionalConditionsofPolicyVM;

            const AdditionalConditionsofPolicyObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            AdditionalConditionsofPolicyVM.pushElement(
                AdditionalConditionsofPolicyObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, AdditionalConditionsofPolicyVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }
            
            AdditionalConditionsofPolicyVM.value.splice(index, 1);
            _.set(submissionVM.value, AdditionalConditionsofPolicyPath, AdditionalConditionsofPolicyVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, AdditionalConditionsofPolicyPath, AdditionalConditionsofPolicyVM?.value]
    );


const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

if (path === 'addConOfPolFie') {
                const value = item.addConOfPolFie ? item.addConOfPolFie : '';
               
                    return (
                        <InputField
                            id={index + path}
                            className={styles.tableColumn}
                            path={path}
                            dataType="String"
                            onValueChange={(val, changedPath) => {
                                item.addConOfPolFie = val;
                                handleValueChange(val, changedPath, index);
                            }}
                            value={value}
                        />
                    );
            }


}, [handleValueChange, translator, AdditionalConditionsofPolicyVM?.children, AdditionalConditionsofPolicyVM?.length, AdditionalConditionsofPolicyVM?.value]) 

const removeAssignmentTableRow = useCallback(
        (item, index) => (
                <Link
                    onClick={(e) => removeAssignmentItem(e, index, item)}
                    className={classNames(styles.deleteSection, styles.deleteRow)}
                >
                    <Icon icon="mi-delete" className={styles.deleteIcon} />
                </Link>
            ),
        [removeAssignmentItem]
    );

 const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`AdditionalConditionsofPolicyTable`]: {
            data: AdditionalConditionsofPolicyVM?.value,
        }
        
    }), [AdditionalConditionsofPolicyVM?.value])

const resolvers = {
        resolveCallbackMap: {
            addAdditionalConditionsofPolicy,
            getTableCell,
            removeAssignmentTableRow
        }
    };

const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
                metadata.pageContent,
                AdditionalConditionsofPolicyVM,
                fieldId,
                fieldPath,
                overrideProps
            ),
        [AdditionalConditionsofPolicyVM, overrideProps]
    );

return (
        <ViewModelForm            
            uiProps={metadata.pageContent}
            model={AdditionalConditionsofPolicyVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

AdditionalConditionsofPolicyComponent.propTypes = wizardProps;
export default withRouter(AdditionalConditionsofPolicyComponent);
